import {
  receiveData,
  receiveError,
  requestData
} from "../api/http"

import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const MIGRATION_HISTORY  = 'MIGRATION_HISTORY'
export const MIGRATION_PENDING  = 'MIGRATION_PENDING'
export const MIGRATION_PROGRESS = 'MIGRATION_PROGRESS'
export const MIGRATION_SUCCESS  = 'MIGRATION_SUCCESS'
export const MIGRATION_CLEAR    = 'MIGRATION_CLEAR'
export const MIGRATION_ERROR    = 'MIGRATION_ERROR'
export const MIGRATION_FAILED   = 'MIGRATION_FAILED'

export const AWS_MIGRATION_PENDING  = 'AWS_MIGRATION_PENDING'
export const AWS_MIGRATION_HISTORY  = 'AWS_MIGRATION_HISTORY'
export const AWS_MIGRATION_ERROR    = 'AWS_MIGRATION_ERROR'

export const AWS_RETRY_PENDING  = 'AWS_RETRY_PENDING'
export const AWS_RETRY_SUCCESS  = 'AWS_RETRY_SUCCESS'
export const AWS_RETRY_ERROR    = 'AWS_RETRY_ERROR'

export const WASABI_MIGRATION_PENDING  = 'WASABI_MIGRATION_PENDING'
export const WASABI_MIGRATION_HISTORY  = 'WASABI_MIGRATION_HISTORY'
export const WASABI_MIGRATION_ERROR    = 'WASABI_MIGRATION_ERROR'

export const WASABI_RETRY_PENDING  = 'WASABI_RETRY_PENDING'
export const WASABI_RETRY_SUCCESS  = 'WASABI_RETRY_SUCCESS'
export const WASABI_RETRY_ERROR    = 'WASABI_RETRY_ERROR'


export const on_migration_failed = migration => ({
    type : MIGRATION_FAILED,
    data : migration
})

export const on_migration_progress = migration => ({
  type : MIGRATION_PROGRESS,
  data:migration
})

export const on_migration_complete = migration => ({
  type : MIGRATION_SUCCESS,
  data:migration
})

export const clear_migration = (migration, func) => {
  if(!migration || migration.status !=='Processing' || migration.percent === 100)
    return dispatch => {
      dispatch(receiveData(MIGRATION_CLEAR, {id: (migration||{}).id}))
      func()
    }
  return dispatch => {
    dispatch(requestData(MIGRATION_PENDING))
    CloudFlyerAPI
      .transfer
      .migration
      .cancel(migration.id)
      .then(() => {
        dispatch(receiveData(MIGRATION_SUCCESS, {[migration.id]:migration}))
        func()
      })
      .catch(err => {
        dispatch(receiveError(MIGRATION_ERROR, err))
        func()
      })
  }
}

export const refresh_migrations_history = () => {
  return dispatch => {
    dispatch(requestData(MIGRATION_PENDING))
    CloudFlyerAPI
      .transfer
      .migration
      .history()
      .then(res => dispatch(receiveData(MIGRATION_HISTORY, {history:((res||{}).data||{})})))
      .catch(err => dispatch(receiveError(MIGRATION_ERROR, err)))
  }
}

export const aws_migrations_history = (userId) => {
  return dispatch => {
    dispatch(requestData(AWS_MIGRATION_PENDING))
    CloudFlyerAPI
      .transfer
      .migration
      .historyAWS(userId)
      .then(res => dispatch(receiveData(AWS_MIGRATION_HISTORY, {awshistory:((res||{}).data||{})})))
      .catch(err => dispatch(receiveError(AWS_MIGRATION_ERROR, err)))
  }
}


export const aws_migrations_retry = (migration) => {
  return dispatch => {
    dispatch(requestData(AWS_RETRY_PENDING))
    CloudFlyerAPI
      .transfer
      .migration
      .retryAWS(migration)
      .then(res => dispatch(receiveData(AWS_RETRY_SUCCESS, {})))
      .catch(err => dispatch(receiveError(AWS_RETRY_ERROR, err)))
  }
}

export const wasabi_migrations_history = (userId) => {
  return dispatch => {
    dispatch(requestData(WASABI_MIGRATION_PENDING))
    CloudFlyerAPI
      .transfer
      .migration
      .historyWasabi(userId)
      .then(res => dispatch(receiveData(WASABI_MIGRATION_HISTORY, {wasabihistory:((res||{}).data||{})})))
      .catch(err => dispatch(receiveError(WASABI_MIGRATION_ERROR, err)))
  }
}


export const wasabi_migrations_retry = (migration) => {
  return dispatch => {
    dispatch(requestData(WASABI_RETRY_PENDING))
    CloudFlyerAPI
      .transfer
      .migration
      .retryWasabi(migration)
      .then(res => dispatch(receiveData(WASABI_RETRY_SUCCESS, {})))
      .catch(err => dispatch(receiveError(WASABI_RETRY_ERROR, err)))
  }
}
